<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Carreras</h4>
        <button type="button" class="btn btn-primary" routerLink="/addCareer">Agregar Carrera</button>
    </div>

    <table *ngIf="listCareers.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
            <th scope="col">Duracíon</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listCareers" class="table-active">
            <td>{{ item.name }}</td>
            <td>{{ item.duration }}</td>
            <td>
                <button routerLink="/editCareer/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteCareer(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listCareers.length == 0">No hay carreras para mostrar</h5>
</div>
